import React from 'react';
import fetch from './../fetch';
import {Modal, message} from 'antd';
import utils from './../../utils';
/**
 * publish
 * @param {*} data 
 */
const publish = (data) => {
    return fetch.post('/listen/generate/insert', data)
    // .then(response => {
    //     if(response.code === 200) {
    //         message.success(response.message);
    //     }
    // });
}

const querySearchTypeTree = (id , keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.get('/listen/enter/targetTree/'+id, keywords)
    .then(response => response.payload.data)
    .then(result => {
        const data = transform(utils.tree(result));
        const maps = codes(result);
        return {
            data,
            maps
        }
    })
}

const transform = (data) => {
    return data.map((d) => {
        var current = {
            label: d.label,
            key: d.id + '',
            value: d.id + ''
        };

        if(d.children) {
            current.children = transform(d.children);
        }
        return current;
    });
}

const codes = (data) => {
    const maps = {};
    data.forEach(d => {
        maps[d.id] = d.label;
    });

    return maps;
}

export default {
    publishURL: '/listenManager/publish',
    publish,
    querySearchTypeTree
}